import { ProjectDocRepository } from "./ProjectDocRepository";

interface SpaceImageLike {
  id: string;
  spaceName: string;
  imageUrl: string;
  storagePath: string;
  createdAt: number;
}

class SpaceGalleryRepository extends ProjectDocRepository<SpaceImageLike[]> {
  readonly key = "space-gallery";
  readonly defaultValue: SpaceImageLike[] = [];
}

export const spaceGalleryRepository = new SpaceGalleryRepository();
